import { isEmail, isEmailMaxLength, isOrderNumber } from '@/utils/validators/helper'
const ORDER_NUMBER_LENGTH_LIMIT = 8

export interface InquiryFields {
  category: string
  name: string | null
  email: string | null
  orderNumber: string | null
  content: string
}

export default class InquiryValidator {
  private fields: Partial<InquiryFields>

  constructor(fields: Partial<InquiryFields>) {
    this.fields = fields
  }

  isEmailFormatValid(): boolean {
    return !!this.fields.email && isEmail(this.fields.email)
  }

  isEmailLengthValid(): boolean {
    return !!this.fields.email && !isEmailMaxLength(this.fields.email)
  }

  isOrderNumberFormatValid(): boolean {
    return !!this.fields.orderNumber && isOrderNumber(this.fields.orderNumber)
  }

  isOrderNumberLengthValid(): boolean {
    // 8文字以内
    return !!this.fields.orderNumber && this.fields.orderNumber.length <= ORDER_NUMBER_LENGTH_LIMIT
  }
}
